<template>
  <div id="app">
    <notifications group="foo" />
    <router-view/>
    <div class="loading-mask" v-show="$store.getters.loading"></div>
  </div>
</template>
<script>
  export default {
    mounted(){
        this.$store.commit('auth/setContacto', null)
    }
  }
</script>
